import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { loginFowebPortalUser } from "../api/fowebportalUsers";
import LanguageToggle from "../components/LanguageToggle";
import { useLanguage } from "../context/LanguageContext";
import { readPortalSession, savePortalSession } from "../utils/portalSession";
import "./LoginPage.css";

function IconEye({ off = false }) {
  if (off) {
    return (
      <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M3 3l18 18" />
        <path d="M10.6 10.7a2 2 0 002.7 2.7" />
        <path d="M9.9 5.2A10.5 10.5 0 0121 12c-.7 1.1-1.6 2.1-2.6 2.9" />
        <path d="M6.1 6.4C4.4 7.6 3 9.2 2.1 12c1.6 4.6 5.5 7.5 9.9 7.5 1.5 0 2.9-.3 4.2-.9" />
      </svg>
    );
  }
  return (
    <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M2.1 12C3.7 7.4 7.6 4.5 12 4.5S20.3 7.4 21.9 12C20.3 16.6 16.4 19.5 12 19.5S3.7 16.6 2.1 12z" />
      <circle cx="12" cy="12" r="2.6" />
    </svg>
  );
}

function LoginPage() {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  if (readPortalSession()) {
    return <Navigate to="/" replace />;
  }

  async function onSubmit(event) {
    event.preventDefault();
    const nextName = String(name || "").trim();
    if (!nextName || !password) {
      setError(t.required);
      return;
    }
    try {
      setSaving(true);
      setError("");
      const user = await loginFowebPortalUser({ name: nextName, password });
      savePortalSession(user);
      navigate("/", { replace: true });
    } catch (err) {
      const message = String(err?.message || "");
      setError(message === "Invalid credentials" ? t.invalid : message || t.failed);
    } finally {
      setSaving(false);
    }
  }

  return (
    <main className="portal-login">
      <div className="portal-login__bar">
        <LanguageToggle />
      </div>
      <form className="portal-login__card" onSubmit={onSubmit}>
        {error ? <p className="portal-login__error">{error}</p> : null}
        <label className="portal-login__label">
          {t.name}
          <input
            className="portal-login__input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoComplete="username"
            required
          />
        </label>
        <label className="portal-login__label">
          {t.password}
          <span className="portal-login__password">
            <input
              className="portal-login__input portal-login__input--password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className="portal-login__eye"
              onClick={() => setShowPassword((current) => !current)}
              aria-label={showPassword ? t.hidePassword : t.showPassword}
            >
              <IconEye off={showPassword} />
            </button>
          </span>
        </label>
        <button type="submit" className="portal-login__submit" disabled={saving}>
          {saving ? t.submitting : t.submit}
        </button>
      </form>
    </main>
  );
}

export default LoginPage;
